import { useQuery } from 'react-query';
import { apiClient } from '../../../services/ApiClient';
import { ApiEndpoints } from '../../../constants/api-constants';
import { Queries, QueryCacheConfig } from '../../../constants/query-constants';
import { type TargetVessel } from '../../../types';
import { buildSearchFilter } from '../utils/search-utils';
import { type SearchResults, type VesselSearchResultViewModel } from '../types';

export const useVesselsSearchQuery = (
  searchPhrase: string,
  canSearch: boolean,
  operation: string,
  targetVessel: TargetVessel
): SearchResults<VesselSearchResultViewModel> => {
  const getResults = async (): Promise<VesselSearchResultViewModel[]> => {
    const searchFilter = buildSearchFilter(searchPhrase, operation, targetVessel?.mmsi);
    return apiClient.get<VesselSearchResultViewModel[]>(ApiEndpoints.search.getVessels(searchFilter));
  };

  const { data, isLoading } = useQuery({
    ...QueryCacheConfig[Queries.SearchVessel],
    queryKey: [Queries.SearchVessel, searchPhrase, operation, targetVessel?.mmsi],
    queryFn: getResults,
    enabled: canSearch,
  });

  return {
    isLoading,
    data,
  };
};
